'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_1 = require('tslib');
var Vue = _interopDefault(require('vue'));
var util = require('../util');
var IconLoading = _interopDefault(require('../icon-loading'));

var render = {render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tap",rawName:"v-tap"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"toast",on:{"touchmove":function($event){$event.preventDefault();},"click":function($event){_vm.type !== 'loading' && _vm.onHide();}}},[(_vm.type === 'text')?_c('div',{staticClass:"toast-message",domProps:{"innerHTML":_vm._s(_vm.text)}}):(_vm.type)?_c('div',{class:['toast-box', ("toast-box-" + _vm.type)]},[(_vm.type === 'loading')?_c('icon-loading'):_c('div',{class:("icon-" + _vm.type + "-outline")}),_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")],1):_vm._e(),_vm._v(" "),(_vm.type === 'loading')?_c('div',{staticClass:"toast-mask"}):_vm._e()])},staticRenderFns:[]}

var Toast = Vue.extend(tslib_1.__assign({}, render, { props: {
        text: String,
        type: String,
        show: Boolean,
        onHide: Function
    }, components: { IconLoading: IconLoading } }));
var toast = util.create('toast', Toast);

exports.Toast = Toast;
exports.default = toast;
